<template>
    <div>
        <vs-row vs-type="flex" vs-align="center">
            <vs-col vs-w="6">
                <span :class="isMobile() ? 'titleMob' : 'title'">{{ $t("message.cashMangement") }}</span>
                <div class="user-info mt-4">
                    <h5>{{ $t("lang.hi") }} {{ currentUser.name }}</h5>
                    <h5>{{ $t("lang.welcome") }}：{{ customer.accountId }}</h5>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="text-right">
                    <span class="time">{{$t('message.lastUpdate')}}: {{currentUser.updatedAt | timeFormat}}</span>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="mt-4">
                    <h5>{{ $t("lang.total_amount_of_fixed_custody") }}：{{ customer.fixedTrAccount ? parseInt(customer.fixedTrAccount).toLocaleString() : "?????" }}</h5>
                    <h5>{{ $t("lang.fixed_custody_account_number") }}：{{ customer.fixedTrustAccountNumber }}</h5>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="text-right">
                    <div class="mt-4">
                        <h5>{{ $t("lang.currency") }}：{{ $t('lang.usd') }}</h5>
                        <h5>{{ $t("lang.trust_advisor_number") }}：{{ customer.trustAdvistorNumber ? customer.trustAdvistorNumber : "?????" }}</h5>
                    </div>
                </div>
            </vs-col>
        </vs-row>
        <div class="fixed-number common-table table-container mt-5">
            <table style="width: 100%;">
                    <tr>
                        <th>{{ $t("lang.fixed_custody_number") }}</th>
                        <th>{{ $t("lang.effective_date") }}</th>
                        <th>{{ $t("lang.maturity_date") }}</th>
                        <th>{{ $t("lang.management_currency") }}</th>  
                        <th>{{ $t("lang.custody_amount") }}</th>
                        <th>{{ $t("lang.standard_return") }}</th>
                        <th>{{ $t("lang.beneficiary") }}</th>
                        <th>{{ $t("lang.beneficiary_after_death") }}</th>
                        <th>{{ $t("lang.note") }}</th>
                    </tr>
                    <tr v-for="item in fixedTrust" :key="item._id">
                        <td>{{ item.fixedNumber }}</td>
                        <td>{{ moment(item.date).format("DD/MM/YYYY") }}</td>
                        <td>{{ moment(item.maturityDate).format("DD/MM/YYYY") }}</td>
                        <td>{{ item.currency }}</td>
                        <td>{{ formatCurrency(item.trustAmount) }}</td>
                        <td>{{ item.expectedReturn }}</td>
                        <td>{{ item.livingBeneficiary }}</td>
                        <td>{{ item.deathBeneficiary }}</td>
                        <td>{{ item.note }}</td>
                        <td>
                            <button @click="handleDetails(item._id)" class="action-btn">{{ $t("lang.details") }}</button>
                        </td>
                    </tr>
                </table>
        </div>
        <vs-row vs-type="flex" vs-align="center">
            <vs-col vs-w="6">
                <div class="mt-4">
                    <h5>{{ $t("lang.total_amount_of_current_custody") }}：{{ customer.demandTrAmount ? parseInt(customer.demandTrAmount).toLocaleString() : "?????" }}</h5>
                    <h5>{{ $t("lang.current_custody_account_number") }}：{{ customer.demandDepositTrustAmountAccountNumber }}</h5>
                </div>
            </vs-col>
            <vs-col vs-w="6">
                <div class="text-right">
                    <div class="mt-4">
                        <h5>{{ $t("lang.currency") }}：{{ $t('lang.usd') }}</h5>
                        <h5>{{ $t("lang.trust_advisor_number") }}：{{ customer.trustAdvistorNumber ? customer.trustAdvistorNumber : "?????" }}</h5>
                    </div>
                </div>
            </vs-col>
        </vs-row>
        <div class="demand-deposit common-table table-container mt-5">
            <table style="width: 100%;">
                    <tr>
                        <th>{{ $t("lang.effective_date") }}</th>
                        <th>{{ $t("lang.management_currency") }}</th>  
                        <th>{{ $t("lang.deposit_withdrawal") }}</th>
                        <th>{{ $t("lang.custody_amount") }}</th>
                        <th>{{ $t("lang.account_balance") }}</th>
                        <th>{{ $t("lang.beneficiary") }}</th>
                        <th>{{ $t("lang.beneficiary_after_death") }}</th>
                        <th>{{ $t("lang.note") }}</th>
                    </tr>
                    <tr v-for="item in demandTrust" :key="item._id">
                        <td class="pb-2 pt-2">{{ moment(item.date).format("DD/MM/YYYY") }}</td>
                        <td>{{ item.currency }}</td>
                        <td>{{ $t(item.depositOrWithdrawal) }}</td>
                        <td>{{ formatCurrency(item.amount) }}</td>
                        <td>{{ formatCurrency(item.accountBalance) }}</td>
                        <td>{{ item.livingBeneficiary }}</td>
                        <td>{{ item.deathBeneficiary }}</td>
                        <td>{{ item.note }}</td>
                        <td>
                            <button @click="handleDetails(item._id)" class="action-btn">{{ $t("lang.details") }}</button>
                        </td>
                    </tr>
                </table>
        </div>
    </div>
</template>

<script>

    import {mapGetters} from 'vuex';
    import $cookies from "vue-cookies";
    import moment from 'moment';


    export default {
        beforeRouteEnter(to, from, next){
            if($cookies.get('role') == 'user'){
                next()
            }else if($cookies.get('role') == 'agent'){
                next('/customer')
            }else if($cookies.get('role') == 'admin'|| $cookies.get('role') == 'manager'){
                next('/account_staff')
            }
        },
        data() {
            return {
                fixedTrust: [],
                demandTrust: [],
                customer: {}
            }
        },
        methods: {
            moment,
            handleDetails(id){
                this.$router.push({
                    name:'cash-management-details',
                    params:{
                        id:id
                    }
                })
            },
            formatCurrency(value){
                return value ? parseInt(value).toLocaleString() : "N/A";
            }
        },

        created() {
            let url = process.env.VUE_APP_API_BASEURL + '/api/me?access_token=' + this.$cookies.get('token');
            fetch(url)
            .then((res) => res.json())
            .then((data) => {
                this.fixedTrust = data.responseDetail.fixedTrust;
                this.demandTrust = data.responseDetail.demandTrust;
                this.customer =  data.responseDetail.customer;
            })
        },
        
        computed:{
            ...mapGetters(["currentUser"])
        },
    }
</script>

<style scoped>
.common-table table th{
    text-align: center;
    background-color: #C8DFCE;
    padding: 5px 0px 5px 0px;
    color: #000;
    border-right: 1px solid #fff;
}
.common-table table tr td{
    text-align: center;
}

.common-table table tr th:first-child{
    border-radius: 10px 0px 0px 10px;
}

.common-table table tr th:last-child{
    border-radius: 0px 10px 10px 0px;
    border-right: none;
}
.common-table table{
    border-collapse: separate;
    border-spacing: 0px 10px; 
}

.common-table table tr td{
    text-align: center;
    color: #000;
    border: 1px solid #C8DFCE;
}

.common-table table tr td:first-child{
    border-radius: 10px 0px 0px 10px;
}
.common-table table tr td:last-child{
    border: none;
}
.common-table table tr td:nth-last-child(2) {
    border-radius: 0px 10px 10px 0px;
}
.action-btn{
    color: #fff;
    background-color: #294b33;
    padding: 5px 20px 5px 20px;
    border-radius: 10px;
}

@media (max-width: 768px) {
    .table-container {
        overflow: auto;
    }
}

</style>
